export default __webpack_public_path__ + "static/media/ifm-logo.8b639324.webp";